import React from 'react';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// Components
import ReactECharts from 'echarts-for-react';

const UserChartDonut = ({ account }) => {
    let azureADCount = 0;
    let usernameAndPasswordCount = 0;

    account.users.forEach(user => {
        if (user.provider === 'AzureAD') {
            azureADCount++;
        }
        else if (user.provider === null) {
            usernameAndPasswordCount++;
        }
    });

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [
            {
                name: 'User Allocation',
                type: 'pie',
                color: ['#5470C6', '#D1D1D1'],
                selectedMode: 'single',
                radius: ['0%', '30%'],
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 15,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                label: {
                    position: 'inner',
                    fontSize: 12
                },
                data: [
                    { value: account.users.length, name: 'Allocated' },
                    { value: account.userLimit - account.users.length, name: 'Unallocated' }
                ]
            },
            {
                name: 'Login Provider',
                type: 'pie',
                color: ['#80C4E9', '#F3CA52', '#D1D1D1'],
                radius: ['45%', '70%'],
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 15,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                label: {
                    position: 'inner',
                    fontSize: 12
                },
                data: [
                    { value: azureADCount, name: 'AzureAD' },
                    { value: usernameAndPasswordCount, name: 'Username & Password' },
                    { value: account.userLimit - account.users.length, name: 'Unallocated' }
                ]
            }
        ]
    };

    return (
        <>
            <Toolbar variant="dense" disableGutters sx={{ px: 2 }}>
                <div style={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2">User Allocation and Login Provider</Typography>
                </div>
            </Toolbar>
            <Divider />
            <Box sx={{ p: 0 }}>
                <ReactECharts
                    option={options}
                    style={{ height: 350 }}
                    opts={{ renderer: 'svg' }}
                />
            </Box>
        </>
    );
};

export default UserChartDonut;
